import React from "react";
import styled from "styled-components";

interface HeaderWithSubheaderProps {
  header: string | number;
  subheader?: string | string[] | JSX.Element;
  dataTestId?: string;
  textAlign?: string;
  fontSize?: string;
}

const HeaderWithSubheader: React.FC<HeaderWithSubheaderProps> = ({
  header,
  subheader,
  dataTestId,
  textAlign,
  fontSize,
}) => {
  return (
    <IndividualDataContainer>
      <HeaderData
        $textAlign={textAlign}
        $fontSize={fontSize}
        data-testid={dataTestId}
      >
        {header}
      </HeaderData>
      {subheader && (
        <SubHeaderData $textAlign={textAlign}>
          {Array.isArray(subheader)
            ? subheader.map((v, index) => <div key={index}>{v}</div>)
            : subheader}
        </SubHeaderData>
      )}
    </IndividualDataContainer>
  );
};

const IndividualDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  text: center;
  width: fit-content;
`;

const HeaderData = styled.span<{ $textAlign?: string; $fontSize?: string }>`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 550;
  font-size: ${({ $fontSize }) => $fontSize || "25px"};
  line-height: 28px;
  text-align: ${({ $textAlign }) => $textAlign || "center"};
  letter-spacing: 0.003em;
  color: white;
`;

const SubHeaderData = styled.span<{ $textAlign?: string }>`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 34px;
  text-align: ${({ $textAlign }) => $textAlign || "center"};
  letter-spacing: 0.003em;
  white-space: pre-line;
  color: white;
  line-height: 20px;
`;

export default HeaderWithSubheader;
